<template>
  <div class="single-language-container" @click="actSelectLanguage()">
      <div class="single-language-check" v-if="isTabSelected">
          <langticksvg></langticksvg>
      </div>
      <div class="single-language-select" v-else>
          <img src="@/assets/icons/tick-not-selected.svg" alt />
      </div>
      <div :class="['single-language', isTabSelected ? 'active' : 'inactive']">{{ selectedLanguage.title }}</div>
      <div :class="['single-language-symbol', isTabSelected ? 'single-language-symbol-active' : 'single-language-symbol-inactive']">
          <img :src="require(`@/assets/icons/${selectedLanguage.icon}`)" alt />
      </div>
  </div>
</template>

<script>
export default {
  data() {
      return {
          isTabSelected: false,
          selectedLanguage: '',
      };
  },
  watch: {
      language: {
          handler(newValue) {
              this.isTabSelected = newValue.isActive;
              this.selectedLanguage = newValue;
          },
          deep: true,
      },
  },
  props: ['language'],
  methods: {
      actSelectLanguage() {
          if (this.isTabSelected) return;
          this.isTabSelected = true;
          this.$emit("callbackLang", {
              key: this.language.key,
              local: this.language.local,
              isActive: this.isTabSelected,
          });
      },
  },
  mounted() {
      this.isTabSelected = this.language.isActive;
      this.selectedLanguage = this.language;
  },
  components: {
      langticksvg: () => import("../SvgImages/Ticksvg.vue"),
  },
};
</script>

<style lang="scss" scoped>
  @import "@/sass/_variables.scss";
  @import "./SingleLangauge.scss";
</style>